var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell',{attrs:{"is-link":"","title":"账号资料"},on:{"click":_vm.goAccount}}),_c('van-cell',{attrs:{"is-link":"","title":"修改密码"},on:{"click":_vm.goReset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }